/**
 * @module modules/existing-bug-dialog-sk
 * @description <h2><code>existing-bug-dialog-sk</code></h2>
 *
 * Dialog to show when user wants to edit a bug to associate with the alert.
 *
 * Takes the following inputs:
 * Request parameters:
 *   bug_id: Bug ID number, as a string (when submitting the form).
 *   project_id: Monorail project ID (when submitting the form).
 *   keys: Comma-separated alert keys in urlsafe format (when submitting the form).
 *   confirm: If non-empty, associate alerts with a bug ID even if
 *       it appears that the alerts already associated with that bug
 *       have a non-overlapping revision range.
 *
 * Once a validated user submits this dialog, there'll be an attempt to submit a
 * bug id and a project id. If succesful, user is re-directed to the another page and close the dialog. If unsuccesful,
 * an error message toast will appear.
 *
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ExistingBugDialogSk", {
    enumerable: true,
    get: function() {
        return ExistingBugDialogSk;
    }
});
require("../../../elements-sk/modules/select-sk");
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _jsonOrThrow = require("../../../infra-sk/modules/jsonOrThrow");
const _json = require("../json");
const _errorMessage = require("../../../elements-sk/modules/errorMessage");
require("../../../elements-sk/modules/icons/close-icon-sk");
require("../../../elements-sk/modules/spinner-sk");
require("../window/window");
const _telemetry = require("../telemetry/telemetry");
const _anomaly = require("../common/anomaly");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
var _ExistingBugDialogSk;
let ExistingBugDialogSk = (_ExistingBugDialogSk = class ExistingBugDialogSk extends _lit.LitElement {
    setAnomalies(anomalies, traceNames) {
        this.anomalies = anomalies;
        this.traceNames = traceNames;
    }
    updated(changedProperties) {
        if (changedProperties.has('anomalies') || changedProperties.has('traceNames')) {
            if (this._form) {
                this._form.reset();
            }
        }
    }
    createRenderRoot() {
        // Render to the component itself to preserve existing styling mechanisms.
        return this;
    }
    render() {
        return (0, _lit.html)`
    <dialog id="existing-bug-dialog">
      <h2>Existing Bug</h2>
      <div id="add-to-existing-bug">
        <button id="closeIcon" @click=${this.closeDialog} type="close">
          <close-icon-sk></close-icon-sk>
        </button>
        <form id="existing-bug-form" @submit=${this._onSubmit} @close=${this._onClose}>
          <label for="existing-bug-dialog-select-project">Project</label>
          <select id="existing-bug-dialog-select-project" @input=${this.projectIdToggle}>
            ${ExistingBugDialogSk.allProjectIds(this)}
          </select>
          <label for="bug_id">Bug ID</label>
          <input type="text"
            id="bug_id"
            placeholder="123456"
            pattern="[0-9]{5,9}"
            title="Bug ID must be a number, between 5 and 9 digits."
            required autocomplete="off"></input>
          <br></br>
          <div>
            <spinner-sk id="loading-spinner" ?active=${this._busy || this._fetchingSuggestions}></spinner-sk>
          </div>
          <div class="bug-list">${this.associatedBugListTemplate()}</div>
          <div class="footer">
            <button id="file-button" class="submit" @click=${this.addAnomalyWithExistingBug} type="submit" ?disabled=${this._busy}>Submit</button>
            <button id="close-button" class="close" @click=${this.closeDialog} type="close" ?disabled=${this._busy}>Close</button>
          </div>
        </form>
      </div>
    </dialog>
  `;
    }
    _onSubmit(e) {
        e.preventDefault();
        this.addAnomalyWithExistingBug();
    }
    _onClose(e) {
        e.preventDefault();
        this._associatedBugIds.clear();
    }
    closeDialog() {
        this._active = false;
        this._busy = false;
        if (this._dialog) {
            this._dialog.close();
        }
    }
    projectIdToggle(e) {
        const select = e.target;
        this._projectId = select.value;
    }
    /**
   * Read the form for choosing an existing bug number for an anomaly alert.
   * Upon success, we redirect the user in a new tab to the existing bug.
   * Upon failure, we keep the dialog open and show an error toast.
   */ async addAnomalyWithExistingBug() {
        var _this__bugIdInput;
        this._busy = true;
        // Extract bug_id.
        const bugId = (_this__bugIdInput = this._bugIdInput) === null || _this__bugIdInput === void 0 ? void 0 : _this__bugIdInput.value;
        this.bug_id = +bugId;
        let anomalyKeys = this.anomalies.map((a)=>a.id);
        if (anomalyKeys.length === 0) {
            _telemetry.telemetry.increaseCounter(_telemetry.CountMetric.ExistingBugDialogSkBugIdUsedAsAnomalyKey, {
                module: 'existing-bug-dialog-sk',
                function: 'addAnomalyWithExistingBug'
            });
            anomalyKeys = [
                this.bug_id.toString()
            ];
        }
        const requestBody = {
            bug_id: this.bug_id,
            keys: anomalyKeys,
            trace_names: this.traceNames
        };
        fetch('/_/triage/associate_alerts', {
            method: 'POST',
            body: JSON.stringify(requestBody),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(_jsonOrThrow.jsonOrThrow).then((json)=>{
            if (json && json.error) {
                this._busy = false;
                (0, _errorMessage.errorMessage)(json.error);
                return;
            }
            this._busy = false;
            // Update anomalies to reflected the existing Bug Id.
            const newAnomalies = this.anomalies.map((a)=>_object_spread_props(_object_spread({}, a), {
                    bug_id: this.bug_id
                }));
            this.anomalies = newAnomalies; // Triggers update if we were open
            this.closeDialog();
            // Let explore-simple-sk and chart-tooltip-sk that anomalies have changed and we need to re-render.
            this.dispatchEvent(new CustomEvent('anomaly-changed', {
                bubbles: true,
                composed: true,
                detail: {
                    traceNames: this.traceNames,
                    anomalies: this.anomalies,
                    bugId: this.bug_id
                }
            }));
        }).catch(async (err)=>{
            this._busy = false;
            let msg = 'Associate alerts request failed due to an internal server error. Please try again.';
            if (err && err.resp) {
                try {
                    const text = await err.resp.text();
                    if (text) {
                        msg = text;
                    }
                } catch (_e) {
                // If reading the response stream fails (e.g., stream was already consumed,
                // connection severed mid-transfer, or body is empty), we gracefully fall back
                // to the default internal server error message defined above.
                }
            }
            (0, _errorMessage.errorMessage)(msg);
        });
    }
    async fetch_associated_bugs() {
        this._fetchingSuggestions = true;
        const req = (0, _anomaly.GetEmptyGroupReportRequest)();
        req.anomalyIDs = String(this.anomalies.map((a)=>a.id));
        await fetch('/_/anomalies/group_report', {
            method: 'POST',
            body: JSON.stringify(req),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(_jsonOrThrow.jsonOrThrow).then(async (json)=>{
            // Make the .then callback async
            // Legacy anomalies follow the SID path if user selects
            // multiple regressions, but SQL anomalies don't.
            // SQL implementation is not supposed to use SID,
            // we will monitor any SID usage to assert this claim.
            if (json.sid && json.sid !== '') {
                const sid = json.sid;
                _telemetry.telemetry.increaseCounter(_telemetry.CountMetric.SIDRequiringActionTaken, {
                    module: 'existing-bug-dialog-sk',
                    function: 'fetch_associated_bugs'
                });
                await this.fetch_associated_bugs_withSid(sid);
            } else {
                const anomalies = json.anomaly_list || [];
                this.getAssociatedBugList(anomalies);
            }
            if (this._associatedBugIds.size !== 0) {
                await this.fetch_bug_titles(); // Await the fetch_bug_titles() call
            }
        });
        this._fetchingSuggestions = false;
    }
    async fetch_associated_bugs_withSid(sid) {
        const req = (0, _anomaly.GetEmptyGroupReportRequest)();
        req.sid = sid;
        await fetch('/_/anomalies/group_report', {
            method: 'POST',
            body: JSON.stringify(req),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(_jsonOrThrow.jsonOrThrow).then((json)=>{
            const anomalies = json.anomaly_list || [];
            this.getAssociatedBugList(anomalies);
        });
    }
    async fetch_bug_titles() {
        const bugIds = Array.from(this._associatedBugIds);
        await fetch('/_/triage/list_issues', {
            method: 'POST',
            body: JSON.stringify({
                IssueIds: bugIds
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(_jsonOrThrow.jsonOrThrow).then((json)=>{
            const issueList = json.issues;
            const newMap = {};
            issueList.forEach((issue)=>{
                const issueid = issue.issueId ? Number(issue.issueId) : 0;
                if (this._associatedBugIds.has(issueid)) {
                    var _issue_issueState;
                    newMap[issueid] = ((_issue_issueState = issue.issueState) === null || _issue_issueState === void 0 ? void 0 : _issue_issueState.title) ? issue.issueState.title : '';
                }
            });
            this.bugIdTitleMap = newMap;
        });
    }
    getAssociatedBugList(anomalies) {
        const newSet = new Set();
        anomalies.forEach((anomaly)=>{
            if (anomaly.bug_id && anomaly.bug_id !== 0) {
                newSet.add(anomaly.bug_id);
            }
        });
        this._associatedBugIds = newSet;
    }
    associatedBugListTemplate() {
        if (this.anomalies) {
            if (this._associatedBugIds.size === 0) {
                return (0, _lit.html)``;
            }
            return (0, _lit.html)`
        <h4>Associated bugs in the same Anomaly group</h4>
        <ul id="associated-bugs-table">
          ${Array.from(this._associatedBugIds).map((bugId)=>{
                return (0, _lit.html)` <li>
              <a href="${`${this._bug_host_url}/${bugId}`}" target="_blank">${bugId}</a>
              <span id="bug-title">${this.bugIdTitleMap[bugId]}</span>
            </li>`;
            })}
        </ul>
      `;
        }
        return (0, _lit.html)``;
    }
    open() {
        if (this._dialog) {
            this._dialog.showModal();
        }
        this._active = true;
    }
    get isActive() {
        return this._active;
    }
    constructor(...args){
        super(...args);
        this._projectId = 'chromium';
        this.anomalies = [];
        this.traceNames = [];
        this.allProjectIdOptions = [
            'chromium'
        ];
        this._active = false;
        this._associatedBugIds = new Set();
        // maintain a map which maps each bug id associates with its title
        this.bugIdTitleMap = {};
        // Host bug url, usually from window.perf.bug_host_url.
        this._bug_host_url = window.perf ? window.perf.bug_host_url : '';
        this._busy = false;
        this._fetchingSuggestions = false;
    }
}, (()=>{
    _ExistingBugDialogSk.allProjectIds = (ele)=>ele.allProjectIdOptions.map((p)=>(0, _lit.html)` <option ?selected=${ele._projectId === p} value=${p} title=${p}>${p}</option> `);
})(), _ExistingBugDialogSk);
_ts_decorate([
    (0, _decorators.query)('#existing-bug-dialog'),
    _ts_metadata("design:type", typeof HTMLDialogElement === "undefined" ? Object : HTMLDialogElement)
], ExistingBugDialogSk.prototype, "_dialog", void 0);
_ts_decorate([
    (0, _decorators.query)('#existing-bug-form'),
    _ts_metadata("design:type", typeof HTMLFormElement === "undefined" ? Object : HTMLFormElement)
], ExistingBugDialogSk.prototype, "_form", void 0);
_ts_decorate([
    (0, _decorators.query)('#bug_id'),
    _ts_metadata("design:type", typeof HTMLInputElement === "undefined" ? Object : HTMLInputElement)
], ExistingBugDialogSk.prototype, "_bugIdInput", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", typeof _json.ProjectId === "undefined" ? Object : _json.ProjectId)
], ExistingBugDialogSk.prototype, "_projectId", void 0);
_ts_decorate([
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", Array)
], ExistingBugDialogSk.prototype, "anomalies", void 0);
_ts_decorate([
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", Array)
], ExistingBugDialogSk.prototype, "traceNames", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Boolean)
], ExistingBugDialogSk.prototype, "_active", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ExistingBugDialogSk.prototype, "_associatedBugIds", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Object)
], ExistingBugDialogSk.prototype, "bugIdTitleMap", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", String)
], ExistingBugDialogSk.prototype, "_bug_host_url", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Boolean)
], ExistingBugDialogSk.prototype, "_busy", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Boolean)
], ExistingBugDialogSk.prototype, "_fetchingSuggestions", void 0);
ExistingBugDialogSk = _ts_decorate([
    (0, _decorators.customElement)('existing-bug-dialog-sk')
], ExistingBugDialogSk);
